module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": _vm.cardData.url,
      "target": "_blank"
    }
  }, [_c('Card', {
    staticClass: "my-card",
    staticStyle: {
      "width": "295px"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('img', {
    staticClass: "my-card-logo",
    attrs: {
      "src": _vm.cardData.imgUrl
    }
  })]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "18"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.cardData.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cardData.des.length > 13 ? _vm.cardData.des.substr(0, 12) + '...' : _vm.cardData.des))])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-8df2c27c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/card.vue
// module id = 30
// module chunks = 0